import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
    selector: 'app-field-error',
    template: `<mat-icon color="warn"
                    *ngIf="control?.invalid && control?.touched"
                    [matTooltip]="getErrorMessage()" matTooltipPosition="above">info</mat-icon>`
})
export class FieldErrorComponent {
    @Input() control!: AbstractControl | null;
    @Input() formatExample: string | null = null;

    public getErrorMessage(): string {
        if (!this.control?.invalid || (!this.control.dirty && !this.control.touched))
            return '';
        const errorMessages = [];

        if (this.control.hasError('required'))
            errorMessages.push('Obrigatório.');

        if (this.control.hasError('email'))
            errorMessages.push('E-mail inválido.');

        if (this.control.hasError('minlength'))
            errorMessages.push(`Mínimo ${this.control.getError('minlength')?.requiredLength} caracteres.`);

        if (this.control.hasError('maxlength'))
            errorMessages.push(`Máximo ${this.control.getError('maxlength')?.requiredLength} caracteres.`);

        if (this.control.hasError('pattern'))
            errorMessages.push(`Formato inválido.\nExemplo: ${this.formatExample}`);

        return errorMessages.length > 0 ? errorMessages.join('\n') : 'Campo inválido.';
    }
}
